<template>
  <div class="grid-body">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th width="50" class="text-center">#</th>
          <th width="200">Invoice No.</th>
          <th>Invoice Detail</th>
          <th width="120" class="text-center">Invoice Date</th>
          <th width="120" class="text-center">Net Amount</th>
          <th width="120" class="text-center">Attachment</th>
          <th class="text-center" width="50"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(invoice, index) in invoices" :key="invoice.id">
          <td>{{ index + 1 }}.</td>
          <td class="text-bold">
            <router-link
              :to="{
                path:
                  '/accounting/' +
                  $route.params.type +
                  '/invoice/edit/' +
                  invoice.id,
              }"
              >IV - {{ invoice.invoice_number }}
            </router-link>
          </td>
          <td>
            <span v-if="invoice.contact_name"
              ><b>Contact</b> - {{ invoice.contact_name }} |
            </span>
            <span v-if="invoice.prepaid_by"
              ><b>Prepaid By</b> - {{ invoice.prepaid_by }} </span
            ><br />
            <span v-if="invoice.reference_invoice_number"
              ><b>Ref Invoice No.</b> - {{ invoice.reference_invoice_number }} |
            </span>
            <span v-if="invoice.due_date"
              ><b>Due Date</b> -
              {{ moment(invoice.due_date).format("DD MMM, YYYY") }} </span
            ><br />
            <span
              v-if="
                invoice.transaction_reference_number ||
                invoice.transaction_date_time ||
                invoice.bank_account
              "
            >
              <b>Transaction</b> - {{ invoice.transaction_reference_number }} |
              {{
                moment(invoice.transaction_date_time).format(
                  "DD MMM, YYYY hh:mm a"
                )
              }}
              |
              {{ invoice.account.account_name }}
            </span>
          </td>
          <td class="text-center">
            {{ moment(invoice.invoice_date).format("DD MMM, YYYY") }}
          </td>
          <td class="text-right">
            {{ ezy.comma(invoice.grand_total) }} &#3647;
          </td>
          <td class="text-center">
            <a
              v-if="invoice.attachments"
              :href="invoice.attachments"
              target="_blank"
              class="badge badge-info pointer"
            >
              <i class="fa fa-eye" aria-hidden="true"></i> View
            </a>
            <span class="badge badge-info pointer" v-else> No Attachment </span>
          </td>
          <td class="text-center">
            <div class="btn-group fabric-dropdown">
              <button
                data-toggle="dropdown"
                class="btn btn-primary dropdown-toggle btn-demo-space"
              >
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu pull-right">
                <li>
                  <router-link
                    :to="{
                      path:
                        '/accounting/' +
                        $route.params.type +
                        '/invoice/edit/' +
                        invoice.id,
                    }"
                    class="pointer"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i> Edit
                  </router-link>
                </li>
                <li>
                  <a class="pointer" @click="$emit('delete', index)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>

        <tr v-if="loading">
          <td class="text-center" colspan="7">
            <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
            Loading ...
          </td>
        </tr>
        <tr v-if="noMoreData">
          <td class="text-center" colspan="7">No More Data</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";
import ezy from "../Tools/ezyFunction";
export default {
  props: ["invoices", "loading", "noMoreData"],
  data() {
    return {
      ezy,
      moment,
    };
  },
};
</script>
